var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edpWaterBg",style:((_vm.opacity ? 'opacity:' + _vm.opacity + ';' : '') +
    (_vm.zIndex ? 'zIndex:' + _vm.zIndex + ';' : ''))},_vm._l((_vm.num || 300),function(itemWater,indexWater){return _c('div',{key:'water' + indexWater,staticClass:"edpWaterBg-waterSign-in",style:((_vm.percent ? 'width:' + _vm.percent + ';' : '') +
      '' +
      (_vm.itemHeight ? 'height:' + _vm.itemHeight + ';' : ''))},[_c('span',[_vm._v(_vm._s(_vm.utils.sercetWaterSign(_vm.userInfoMap.cdsid)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }